import { BaseModel } from "sjs-base-model";

export default class NuovoNotaFormModel extends BaseModel {
    public readonly nota: string = "";
    public readonly followers: string = "";
    public readonly notaInterna: boolean = false;

    constructor(data: Partial<NuovoNotaFormModel>) {
        super();

        this.update(data);
    }
}
